/* unplugin-vue-components disabled */import { render } from "./ai-chat.vue?vue&type=template&id=0a22c84a&scoped=true"
import script from "./ai-chat.vue?vue&type=script&lang=js"
export * from "./ai-chat.vue?vue&type=script&lang=js"

import "./ai-chat.vue?vue&type=style&index=0&id=0a22c84a&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a22c84a"],['__file',"src/components/ai-chat-v2/ai-chat.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a22c84a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a22c84a', __exports__)) {
    api.reload('0a22c84a', __exports__)
  }
  
  module.hot.accept("./ai-chat.vue?vue&type=template&id=0a22c84a&scoped=true", () => {
    api.rerender('0a22c84a', render)
  })

}


export default __exports__